(function () {

  function isGerman() {
    const lang = document.documentElement.lang || '';
    return lang === 'de' || lang.startsWith('de-');
  }


  async function updateCartAttributes(attributes) {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });

    if (!response.ok) {
      throw new Error('Could not update cart attributes.');
    }

    return response.json();
  }


  function getContainerValues(container) {
    const salutation = container.querySelector(
      '[data-precheckout-salutation]'
    );

    const birthday = container.querySelector(
      '[data-precheckout-birthday]'
    );

    return {
      Salutation: salutation ? salutation.value : '',
      Birthday: birthday ? birthday.value : ''
    };
  }


  function setContainerValues(container, values) {
    const salutation = container.querySelector(
      '[data-precheckout-salutation]'
    );

    const birthday = container.querySelector(
      '[data-precheckout-birthday]'
    );

    if (salutation) {
      salutation.value = values.Salutation || '';
    }

    if (birthday) {
      birthday.value = values.Birthday || '';
    }
  }


  function syncOtherContainers(sourceContainer) {
    const values = getContainerValues(sourceContainer);

    document
      .querySelectorAll('[data-precheckout-data]')
      .forEach(function (container) {
        if (container === sourceContainer) {
          return;
        }

        setContainerValues(container, values);
      });
  }


  function showError(container, message) {
    const error = container.querySelector(
      '[data-precheckout-error]'
    );

    if (!error) {
      return;
    }

    error.textContent = message;
    error.hidden = false;
  }


  function clearError(container) {
    const error = container.querySelector(
      '[data-precheckout-error]'
    );

    if (!error) {
      return;
    }

    error.textContent = '';
    error.hidden = true;
  }


  function validateBirthday(container) {
    const birthday = container.querySelector(
      '[data-precheckout-birthday]'
    );

    /*
     * Geburtstag ist optional.
     */
    if (!birthday || !birthday.value) {
      return true;
    }

    const selectedDate = new Date(
      birthday.value + 'T00:00:00'
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (
      Number.isNaN(selectedDate.getTime()) ||
      selectedDate > today
    ) {
      showError(
        container,
        isGerman()
          ? 'Bitte gib ein gültiges Geburtsdatum an.'
          : 'Please enter a valid date of birth.'
      );

      birthday.focus();

      return false;
    }

    return true;
  }


  function validate(container) {
    clearError(container);

    /*
     * Anrede und Geburtstag sind beide optional.
     * Nur ein eingetragenes Geburtsdatum muss gültig sein.
     */
    return validateBirthday(container);
  }


  let saveTimer = null;


  function scheduleSave(container) {
    window.clearTimeout(saveTimer);

    saveTimer = window.setTimeout(
      async function () {
        try {
          const values = getContainerValues(container);

          await updateCartAttributes(values);

          syncOtherContainers(container);
        } catch (error) {
          console.error(
            'Precheckout save failed:',
            error
          );
        }
      },
      350
    );
  }


  function initializeContainer(container) {
    if (
      container.dataset.precheckoutInitialized === 'true'
    ) {
      return;
    }

    container.dataset.precheckoutInitialized = 'true';

    const salutation = container.querySelector(
      '[data-precheckout-salutation]'
    );

    const birthday = container.querySelector(
      '[data-precheckout-birthday]'
    );


    if (salutation) {
      salutation.addEventListener(
        'change',
        function () {
          clearError(container);
          scheduleSave(container);
        }
      );
    }


    if (birthday) {
      birthday.addEventListener(
        'change',
        function () {
          clearError(container);
          scheduleSave(container);
        }
      );

      birthday.addEventListener(
        'blur',
        function () {
          scheduleSave(container);
        }
      );
    }
  }


  function initializeAll() {
    document
      .querySelectorAll('[data-precheckout-data]')
      .forEach(initializeContainer);
  }


  /*
   * ============================================================
   * CHECKOUT HANDLER
   * ============================================================
   *
   * Wir speichern Anrede/Geburtstag noch einmal final,
   * bevor der normale Shopify Checkout geöffnet wird.
   *
   * Kein Country-Prefill mehr.
   * Keine Tax-ID-Logik mehr.
   */
  document.addEventListener(
    'click',

    async function (event) {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"]'
      );

      if (!checkoutButton) {
        return;
      }

      const form = checkoutButton.closest('form');

      if (!form) {
        return;
      }

      const container = form.querySelector(
        '[data-precheckout-data]'
      );

      if (!container) {
        return;
      }


      if (!validate(container)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();

      checkoutButton.disabled = true;


      try {
        const values = getContainerValues(container);

        await updateCartAttributes(values);

        /*
         * Der ursprüngliche Klick auf "checkout" wurde gestoppt.
         * Deshalb setzen wir das Checkout-Feld manuell wieder ein.
         */
        let checkoutMarker = form.querySelector(
          'input[data-precheckout-checkout-marker]'
        );

        if (!checkoutMarker) {
          checkoutMarker = document.createElement('input');

          checkoutMarker.type = 'hidden';
          checkoutMarker.name = 'checkout';
          checkoutMarker.value = 'checkout';

          checkoutMarker.setAttribute(
            'data-precheckout-checkout-marker',
            'true'
          );

          form.appendChild(checkoutMarker);
        }

        form.submit();

      } catch (error) {
        console.error(
          'Checkout preparation failed:',
          error
        );

        checkoutButton.disabled = false;

        showError(
          container,
          isGerman()
            ? 'Die Angaben konnten nicht gespeichert werden. Bitte versuche es noch einmal.'
            : 'Your information could not be saved. Please try again.'
        );
      }
    },

    true
  );


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }


  /*
   * Cart Drawer kann per AJAX neu gerendert werden.
   */
  const observer = new MutationObserver(function () {
    initializeAll();
  });

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();